// Imports
import {
	faBadgeDollar,
	faCommentsQuestionCheck,
	faFaceSmileHearts,
	faHundredPoints,
	faRocket,
} from '@fortawesome/pro-regular-svg-icons';
import { BannerListItem } from '../../../resources/banner-with-list';


// Items
const items: BannerListItem[] = [
	{
		icon: faBadgeDollar,
		label: 'Unrivaled value',
		description:
			'We offer an extensive (and growing) feature set at a surprisingly affordable price, with no setup fees or hidden costs.',
		link: {
			text: 'See all-inclusive pricing',
			to: '/pricing',
		},
	},
	{
		icon: faRocket,
		label: 'Frequent updates',
		description:
			'Our product improves at an unmatched pace, with a roadmap that’s driven by customer insights through a public feedback portal.',
		link: {
			text: 'See public changelog',
			href: 'https://feedback.hoa-express.com/changelog',
			target: '_blank',
		},
	},
	{
		icon: faHundredPoints,
		label: 'Reliability & polish',
		description:
			'We rapidly squash bugs and maintain rock-solid uptime, focusing on a highly dependable product that works as expected.',
		link: {
			text: 'See transparent status page',
			href: 'https://status.hoa-express.com/',
			target: '_blank',
		},
	},
	{
		icon: faFaceSmileHearts,
		label: 'Ease-of-use',
		description:
			'Customer reviews overwhelming cite how easy our product is. That’s the result of a relentless focus on intuitive design.',
		link: {
			text: 'See honest customer reviews',
			href: 'https://www.trustpilot.com/review/hoa-express.com',
			target: '_blank',
			rel: 'noopener noreferrer',
		},
	},
	{
		icon: faCommentsQuestionCheck,
		label: 'Human support',
		description:
			'Easily reach real humans working in the same office as our product and engineering teams, for fast & accurate help when you need it.',
		link: {
			text: 'See how to get in touch',
			href: 'https://help.hoa-express.com/en/articles/2390052-contact-our-customer-success-team',
			target: '_blank',
		},
	},
];

export default items;
